<template>
    <l-map
      ref="leaflet"
      @hook:mounted="mapInitialization"
      :zoom="config.zoom" :center="[config.center.lat,config.center.lng]">
      <l-tile-layer
        url="http://{s}.tile.osm.org/{z}/{x}/{y}.png" :prefix="false"></l-tile-layer>
<!--      <l-marker :lat-lng="[55.9464418,8.1277591]"></l-marker>-->
      <template v-if="items.total >= 100 && zoom < config.maxZoomForGeoHash">
        <template v-for="(item, index) in items.geo_hash">
          <l-rectangle

              :key="index"
            v-if="item.count > 1"
            :bounds="[[item.box[2], item.box[3]], [item.box[0], item.box[1]]]" :l-style="{ color: 'red', weight: 1 }"
            @click="setBounds(item.box)"
          >

            <l-tooltip>{{item.count}} listings</l-tooltip>

          </l-rectangle>
        </template>
        <template v-for="(item, index) in items.geo_hash"
        >
          <l-circle-marker
              :key="index"
            v-if="item.count === 1"
            :lat-lng="[item.lat, item.lng]"
            :radius="6"
            color="red"
            fillColor="red"
            @click="setBounds(item.box)"
          />
        </template>

     </template>
      <template v-if="items.total < 100 || zoom >= config.maxZoomForGeoHash">
        <template v-for="(item, index) in items.items">
          <l-marker :key="index"  @click="pinClick(item)" :lat-lng="[item._source.location.lat,item._source.location.lon]">

            <l-tooltip v-if="window_width > 440">
              <tooltip :items="item">

              </tooltip>
            </l-tooltip>

          </l-marker>
        </template>
      </template>

<!--      <b-loading :is-full-page="false" v-model="isMapLoading" :can-cancel="true"></b-loading>-->
<!--      <l-polygon v-if="city" :lat-lngs="city.geo.features[0].geometry.coordinates" color="green"></l-polygon>-->
      <l-feature-group  ref="geo">
      <l-geo-json :optionsStyle="{fill:false}" v-if="city"  :geojson="city.geo"></l-geo-json>
      </l-feature-group>
      <l-control position="topright" >

                <b-button v-if="city" type="map_mode_mobile"

                          @click="$emit('clearCity')"
                          icon-right="close-circle"
                >Remove boundary</b-button>

        <b-button v-if="!city" type="map_mode_mobile"
                  icon-left="map"
                  @click="zoomToAll">Show all</b-button>
        <b-button v-if="city" type="is-primary map_mode_mobile"
                  icon-left="map"
                  @click="zoomToAll">Zoom to {{city && city['name']}}, {{city.state.abbreviation}}</b-button>
      </l-control>
<!--      <l-control position="topright" >-->
<!--        <b-button v-if="city" type="is-info is-light map_mode_mobile"-->

<!--                  @click="zoomToAll"-->
<!--                  icon-right="close-circle"-->
<!--        >Remove boundary</b-button>-->
<!--      </l-control>-->
    </l-map>
</template>

<script>

import tooltip from "@/components/listings_map/tooltip";
import configDefault from "@/components/listings_map/map/config";
import {Bounds} from "@/Helpers/bounds";
import L from "leaflet"
import { LMap, LTileLayer, LMarker, LFeatureGroup, LControl, LRectangle, LTooltip, LCircleMarker, LGeoJson } from 'vue2-leaflet';
import 'leaflet/dist/leaflet.css';
delete L.Icon.Default.prototype._getIconUrl;

L.Icon.Default.mergeOptions({
  iconRetinaUrl: require('leaflet/dist/images/marker-icon-2x.png'),
  iconUrl: require('leaflet/dist/images/marker-icon.png'),
  shadowUrl: require('leaflet/dist/images/marker-shadow.png'),
});

export default {
  name: 'leaflet_map',
  components: { tooltip, LMap, LTileLayer, LMarker,LFeatureGroup, LControl, LRectangle, LTooltip,LCircleMarker, LGeoJson },
  props: {
    items:null,
    onPinClick: null,
    /**
     * @type {Query} query
     */
    query: null,
    center: null,
    details_url: null,
    realtor: null,
    city:null
  },
  data() {
    return {
      // result: null,
      isMapLoading: false,
      isMapInitialized: false,
      fitMapOnNextCall: true,
      config: {
        center: {
          lat: null,
          lng: null
        },
        zoom: null
      },
      queryLocal: null,
      zoom: null,
      window_width: null,
      zoomToPrecision: {
        0: 4,
        1: 4,
        2: 4,
        3: 4,
        4: 4,
        5: 4,
        6: 4,
        7: 4,
        8: 4,
        9: 4,
        10: 5,
        11: 5,
        12: 6,
        13: 6,
        14: 7,
        15: 7,
        16: 8,
        17: 8,
        18: 8,
        19: 8,
        20: 8
      }
    }
  },
  computed: {
  },
  methods: {
    zoomToAll() {
     // if(this.items.bounds) {
        //this.setBounds(this.items.bounds);
     // } else {
        if(this.city) {
          const map = this.$refs.leaflet.mapObject;
          //console.log(this.city);
          map.fitBounds(this.$refs.geo.mapObject.getBounds());
        } else {
          this.setBounds(configDefault.defaultBounds.leaflet);
        }

      //}
    },
    zoomToAll800() {

      setTimeout(() =>
        {
          this.zoomToAll();
        }
        , 800);
    },
    pinClick(item){
      this.onPinClick(item, true);
    },
    uniIsMapInitialized(){
      return this.isMapInitialized;
    },
    uniSetBoundsFromQuery(query) {
      const map = this.$refs.leaflet.mapObject;
      var corner1 = L.latLng(query.sw_lat, query.sw_lng),
        corner2 = L.latLng(query.ne_lat, query.ne_lng),
        bounds = L.latLngBounds(corner1, corner2);
      //console.log(bounds);
      map.fitBounds(bounds);
      // map.fitBounds([
      //   [query.sw_lat, query.sw_lng],
      //   [query.ne_lat, query.ne_lng]
      // ]);
     // const mapBounds = map.getBounds();
      this.zoom = map.getZoom();
      //console.log(mapBounds);
    },
    uniGetBounds(){
      const map = this.$refs.leaflet.mapObject;
      const mapBounds = map.getBounds();
      const bounds = new Bounds();
      if(mapBounds && mapBounds._northEast) {
        bounds.ne_lat = mapBounds._northEast.lat;
        bounds.ne_lng = mapBounds._northEast.lng;
        bounds.sw_lat = mapBounds._southWest.lat;
        bounds.sw_lng = mapBounds._southWest.lng;
      }
      return bounds;
    },
    uniGetZoom(){
      const map = this.$refs.leaflet.mapObject;
      return map.getZoom();
    },
    openProperty(item) {
      let result =  this.details_url + '/' + item._source.SystemUrl;

      if(this.realtor) {
        result = result + '?agent=' + this.realtor.id;
      }
      this.$router.push(result);
    },
    // setQueryBounds(map) {
    //   const bounds = map.getBounds();
    //   map.attributionControl.setPrefix(map.getZoom());
    //   //map.attributionControl.removeAttribution();
    //   //map.attributionControl.addAttribution();
    //   /**
    //    * @type {Query} query
    //    */
    //   if(bounds && bounds._northEast) {
    //     this.query.ne_lat = bounds._northEast.lat;
    //     this.query.ne_lng = bounds._northEast.lng;
    //     this.query.sw_lat = bounds._southWest.lat;
    //     this.query.sw_lng = bounds._southWest.lng;
    //   }
    //
    //   const zoom = map.getZoom();
    //   this.query.precision = this.zoomToPrecision[zoom];
    //
    // },
    // setBoundsFromQuery() {
    //   const map = this.$refs.leaflet.mapObject;
    //   map.fitBounds([
    //     [this.query.sw_lat, this.query.sw_lng],
    //     [this.query.ne_lat, this.query.ne_lng]
    //   ]);
    // },
    setBounds(box) {
      const map = this.$refs.leaflet.mapObject;

      map.fitBounds([
        [box[0], box[1]],
        [box[2], box[3]]
      ]);
    },
    mapInitialization() {
      const map = this.$refs.leaflet.mapObject;

      //this.setQueryBounds(map);
      //this.setBoundsFromQuery();
      this.zoom = map.getZoom();
      this.isMapInitialized = true;
      this.$emit('onMapInitialized');

      map.on('moveend', () => {
        //console.log(instance);
        this.zoom = map.getZoom();
        //if(this.fitMapOnNextCall) {
        // this.setQueryBounds(map);
        //}
        this.$emit('onMapMove')
      });
      if(this.city){
        this.zoomToAll800();
      }
    },
    // setBoundsDeb: _.debounce(function(box) {
    //   const map = this.$refs.leaflet.mapObject;
    //   this.fitMapOnNextCall = false;
    //   map.fitBounds([
    //     [box[0], box[1]],
    //     [box[2], box[3]]
    //   ]);
    // }, 400),
    // request: _.debounce(function() {
    //   if (process.client) {
    //     this.isMapLoading = true;
    //     const query = this.queryLocal.clone();
    //     query.limit = 200;
    //     query.page = 1;
    //     query.geo_hash = this.zoom < this.config.maxZoomForGeoHash;
    //     if(query.geo_hash) {
    //       query.limit = 0;
    //     }
    //
    //     getPropertiesByQuery(query).then((result) => {
    //       this.result = result;
    //       this.isMapLoading = false;
    //       if(this.fitMapOnNextCall && items.bounds) {
    //         //this.setBounds(items.bounds);
    //         //this.fitMapOnNextCall = false;
    //       }
    //       document.location.hash = this.queryLocal.toString() + '&modeMap=true';
    //     });
    //   }
    // }, 400),
    reportWindowSize() {

        this.window_width = window.innerWidth;
        //console.log(this.window_width);

    }
  },
  created() {
    // this.result = new Result();
    // if(!this.query) {
    //   this.query = new Query();
    //   this.query.initBaseConfig()
    // }
    if(!this.center) {
      this.config.center = Object.assign({}, configDefault.center);
    } else {
      this.config.center = this.center;
    }
    this.config.zoom = configDefault.zoom.leaflet;
    this.config.maxZoomForGeoHash = configDefault.maxZoomForGeoHash.leaflet;
  },
  mounted() {
    //this.request();
    //   if(this.query) {
    //     this.queryLocal = this.query.clone();
    //   } else  {
    //     this.queryLocal = new Query();
    //   }
    // this.query.geo_hash = true;
    // this.query.precision = 4;
    this.reportWindowSize();

      window.addEventListener("resize", this.reportWindowSize);


  },
  unmounted() {
    this.result = null;
  },
  watch: {
    query: {
      handler() {
        //this.fitMapOnNextCall = true;
        if(this.isMapInitialized) {
          //this.request();
        }
      },
      deep: true
    },
    items: {
      handler() {
        //this.setBoundsDeb(this.items.bounds);
      },
      deep: true
    },
    city: {
      handler() {
        //this.setBoundsDeb(this.items.bounds);
        setTimeout(() =>
        {
          if(this.city) {
            const map = this.$refs.leaflet.mapObject;
            map.fitBounds(this.$refs.geo.mapObject.getBounds());
          }
        }
        , 800);
      },
    },
  },
}
</script>

<style scoped>
</style>
<style >

</style>
